<template>
    <div class="wrapper_group_dashboard ticket-manage-wrapper">
         <div class="group_dashboard">
            <div class="admin_message_wrapper">
                <div class="breadcrumbwrapper">
                    <breadcrumb :items="breadcrumbItems" />
                </div>
                <div class="ticket-card p-4 mt-3 ticket-list-wrapper member_detail">
                    <div class="ticket-header d-flex align-items-center gap-3 flex-wrap" v-if="isLoaded">
                        <div class="ticket-item d-flex align-items-center gap-1 font-14">
                            <span class="itemtitle">Category :</span>
                            <span class="itemvalue fw-semibold clr-black">{{ details.category_name }}</span>
                        </div>
                        <div class="ticket-item d-flex align-items-center gap-1 font-14">
                            <span class="itemtitle">Type :</span>
                            <span class="itemvalue fw-semibold clr-black">Group</span>
                        </div>
                        <div class="ticket-item d-flex align-items-center gap-1 font-14">
                            <span class="itemtitle">Status :</span>
                            <span :class="[details.status === 'Closed' ? 'closeissue-status' : 'issue-status','itemvalue font-13 fw-medium d-inline-flex justify-content-center align-items-center  badgecontainer']">{{ details.status }}</span>
                        </div>
                        <div class="ticket-item d-flex align-items-center gap-1 font-14">
                            <span class="itemtitle">Opened Date :</span>
                            <span class="itemvalue fw-semibold clr-black">{{ details.opened_date }}</span>
                        </div>
                    </div>
                    <!-- HEADER SKELETON -->
                    <div v-else class="d-flex align-items-center gap-3 flex-wrap">
                        <b-skeleton width="120px" height="20px"></b-skeleton>
                        <b-skeleton width="80px" height="20px"></b-skeleton>
                        <b-skeleton width="100px" height="20px"></b-skeleton>
                        <b-skeleton width="140px" height="20px"></b-skeleton>
                    </div>
                    <div class="complaint_section mt-4 pt-2">
                        <div class="page-title mb-4">
                            <h4 class="title font-weight-bold clr-title ">Complaint & Description</h4>
                        </div>
                        <template v-if="isLoaded">
                            <div class="subjectwrapper">
                                <h6 class="complaintHeader font-weight-bold fs-16 clr-title">Subject</h6>
                                <div class="complaintContent fs-16 clr-title">
                                    {{ details.title }}
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <b-skeleton width="200px" height="20px"></b-skeleton>
                            <b-skeleton width="80%" height="25px" class="mt-2"></b-skeleton>
                        </template>
                        <hr>
                        <template v-if="isLoaded">
                            <div class="descriptionwrapper mt-3">
                                <h6 class="complaintHeader font-weight-bold fs-16 clr-title">Description</h6>
                                <div class="complaintContent fs-16 clr-title" v-html="details.details">
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <!-- <b-skeleton width="200px" height="20px"></b-skeleton>
                            <b-skeleton width="80%" height="80px" class="mt-2"></b-skeleton> -->
                            <b-skeleton height="80px"></b-skeleton>
                            <b-skeleton height="60px" class="mt-2"></b-skeleton>
                        </template>
                    </div>
                    <div class="tab-wrapper mt-4">
                        <div class="tab-wrapper-btns d-inline-flex align-items-center gap-1 flex-wrap font-14 ">
                            <button v-for="(tab, index) in tabs" :key="index" class="tab-btn border-0 d-flex align-items-center gap-2 fw-medium"
                                :class="{ active: activeTab === tab }" @click="setActiveTab(tab)">
                                <i :class="tab.icon"></i> {{ tab.title }}
                            </button>
                        </div>
                        <div class="tab-content mt-4">
                            <component
                                :is="activeTab.component"
                                v-if="isLoaded"
                                :key="activeTab.title + '-' + ticketStatus"
                                v-bind="dynamicProps"
                            />
                            <!-- Skeleton tab content -->
                            <div v-else>
                                <div v-for="n in 2" :key="n" class="mb-4">
                                    <div class="comment_item d-flex align-items-start gap-3">
                                        <b-skeleton type="avatar" width="46px" height="46px"></b-skeleton>

                                        <div class="comment_content d-flex flex-column w-100 gap-2">
                                            <div class="d-flex align-items-center gap-2">
                                                <b-skeleton width="120px" height="16px"></b-skeleton>
                                                <b-skeleton width="80px" height="14px"></b-skeleton>
                                            </div>

                                            <b-skeleton width="95%" height="14px"></b-skeleton>
                                            <b-skeleton width="80%" height="14px"></b-skeleton>
                                        </div>
                                    </div>

                                    <div class="mt-3">
                                        <div class="d-flex align-items-center gap-3 document-skeleton">
                                            <b-skeleton type="avatar" width="34px" height="34px"></b-skeleton>

                                            <div class="d-flex flex-column gap-2 w-100">
                                                <b-skeleton width="60%" height="14px"></b-skeleton>
                                                <b-skeleton width="40%" height="14px"></b-skeleton>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-3">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
import TicketIssueComment from './TicketIssueComment.vue';
import TicketIssueDocument from './TicketIssueDocument.vue';
import TicketSubmitterDetail from './TicketSubmitterDetail.vue';
import Api from "@/resource/Api";

export default {
    components: {
        TicketIssueComment,
        TicketIssueDocument,
        TicketSubmitterDetail
    },
    name: "TicketIssueDetail",
    data() {
        return {
            breadcrumbItems: [{ title: "Manage Tickets", active: false, path: { name: "Ticketing" } }, { title: "Issue Detail", active: true }],
            tabs: [
                {
                    title: "Comments",
                    icon: "fas fa-comments w-14",
                    component: TicketIssueComment,
                    passPropsType: "comment"
                },
                {
                    title: "Issue Documents",
                    icon: "fas fa-file",
                    component: TicketIssueDocument,
                    passPropsType: "documents"
                },
                {
                    title: "Submitter Details",
                    icon: "fas fa-user",
                    component: TicketSubmitterDetail,
                    passPropsType: "details"
                },

            ],
            activeTab: null,
            ticketId: this.$route.params.ticketId,
            ticketType: this.$route.params.ticketType === "assigned" ? 2 : 1,
            details: {},
            submitterDetails: {
                name: "",
                email: "",
                contact: "",
                register: "N/A",
                reg_date: "",
                device: "",
                ip_address: "",
            },
            ticketStatus: "",
            isLoaded: false,
        };
    },
    mounted() {
        this.getTicketDetails();
    },
    created() {
        this.activeTab = this.tabs[0];
    },
    computed: {
        dynamicProps() {
            if (this.activeTab.passPropsType === "comment") {
                return { ticketStatus: this.ticketStatus };
            }
            if (this.activeTab.passPropsType === "details") {
                return { submitterDetails: this.submitterDetails };
            }
            return {};
        }
    },
    methods: {
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        getTicketDetails() {
            const url = `tickets/${this.ticketId}/details/${this.ticketType}`
            Api.get(url)
            .then((res) => {
                if(res.data.status==="success" && res.data?.data) {
                    this.details = res.data.data;
                    this.ticketStatus = this.details.status;
                    this.getSubmitterDetails(res.data.data);
                }
            })
            .catch(err => console.error("API Error:", err))
            .finally(() => {
                this.isLoaded = true;
            });
        },
        getSubmitterDetails(data) {
            this.submitterDetails.name = data.submitter_name;
            this.submitterDetails.email = data.submitter_email;
            this.submitterDetails.contact = "";
            this.submitterDetails.register = "";
            this.submitterDetails.reg_date = data.register_date ? data.register_date : "-";
            this.submitterDetails.device = data.device ? data.device : "-";
            this.submitterDetails.ip_address = data.ip_address;
        }
    },

};
</script>

<style src="@/assets/css/group_dashboard/ticket_manage.css"></style>
<style>
.ticket-manage-wrapper .tab-wrapper-btns{
    border-radius: 30px;
    padding: 1px;
}
.ticket-manage-wrapper .tab-wrapper .tab-btn {
   background-color: #fff;
   padding: 14px 24px;
border-radius: 30px;
color: var(--rep-bold-grey-clr);

}
.ticket-manage-wrapper .tab-wrapper .tab-btn svg , .ticket-manage-wrapper .attach-btn svg{
 width: 14px;
height: 14px;
}
.ticket-manage-wrapper .tab-wrapper .tab-btn.active, .ticket-manage-wrapper.tab-wrapper .tab-btn.active .fa-user{
    background-color: var(--rep-primary-clr);
    color: #fff;
}

</style>